import api from "../service/api";
import { createApiStore } from "./genericStore";

// Kur tipi tanımı
export interface CurrencyRates {
    USD: number;
    EUR: number;
    GBP?: number;
}

// Generic store'u ana endpoint ile oluşturuyoruz
const useCurrencyBaseStore = createApiStore<any>("/currency");

export const useCurrencyStore = () => {
    const store = useCurrencyBaseStore();

    return {
        ...store,

        /**
         * Veritabanındaki en güncel USD ve EUR kurlarını getirir.
         * Dashboard ve Fatura ekranlarında kullanılacak ana metot.
         */
        getLiveRates: async (): Promise<CurrencyRates> => {
            try {
                const res = await api.get("/currency/live", { headers: { "ignore-403": "true" } });
                return res.data; // { USD: 34.5, EUR: 36.2 } formatında döner
            } catch (error) {
                console.error("Kurlar yüklenirken hata oluştu:", error);
                // Hata durumunda sistemin çökmemesi için fallback (varsayılan) değerler
                return { USD: 0, EUR: 0 };
            }
        },

        /**
         * TCMB üzerinden kurları manuel olarak tetikleyip veritabanını günceller.
         * Ayarlar sayfasında veya "Kurları Güncelle" butonunda kullanılabilir.
         */
        syncRates: async () => {
            try {
                const res = await api.post("/currency/sync");
                // Kurlar güncellendikten sonra listeyi veya bağlı verileri yenilemek gerekirse:
                // await store.fetchDataDynamic(); 
                return res.data;
            } catch (error) {
                console.error("Kurlar senkronize edilemedi:", error);
                throw error;
            }
        }
    };
};